import * as React from "react";
import { Context } from "@grandvisionhq/carts-v2";
import { useDispatch } from "@grandvisionhq/state";
import { prefillShippingForms } from "../../../StepShipping/actions.js";
import { useCheckoutSettings } from "../../../../context/CheckoutSettings/context/CheckoutSettings/context.js";
const useFormPrefill = (userData) => {
  const checkoutSettings = useCheckoutSettings();
  const shippingDetailsCart = checkoutSettings.shippingDetails;
  const dispatch = useDispatch();
  const { loading, called } = Context.useCart();
  React.useEffect(() => {
    if (called && !loading && userData.status !== "loading") {
      dispatch(
        prefillShippingForms({
          userData,
          cartData: shippingDetailsCart,
          fields: checkoutSettings.shippingFormFields
        })
      );
    }
  }, [dispatch, loading, called, shippingDetailsCart, userData.status]);
};
export {
  useFormPrefill
};
//# sourceMappingURL=use-form-prefill.js.map
